import React from "react";
import {
  AnimatedCard,
  ActionCard,
  ActionTitle,
  ActionRow,
  Label,
  SelectInput,
  TextArea,
} from "../ActionPlan/styles";

// Fallback options if API not available
const FALLBACK_STATUS_OPTIONS = [
  { id: "not_started", name: "Not Started" },
  { id: "in_progress", name: "In Progress" },
  { id: "blocked", name: "Blocked" },
  { id: "completed", name: "Completed" },
];

export default function StatusStep({
  themeColors,
  isFadingOut,
  action,
  index,
  total,
  statusValue,
  noteValue,
  onChangeStatus,
  onChangeNote,
  statusOptions = [],
}) {
  return (
    <AnimatedCard isFadingOut={isFadingOut}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 12 }}>
        <div style={{ fontSize: 14, color: "#6b7280" }}>
          Action {index + 1} of {total}
        </div>
      </div>
      <ActionCard>
        <div style={{ marginBottom: 8 }}>
          <ActionTitle style={{ marginBottom: 6 }}>{action?.title || "Untitled action"}</ActionTitle>
          {action?.description ? (
            <div style={{ color: "#374151", fontSize: 14 }}>{action.description}</div>
          ) : null}
        </div>

        <ActionRow>
          <Label>
            <span style={{ marginRight: 8 }}>Status</span>
            <SelectInput value={statusValue || ""} onChange={(e) => onChangeStatus(action.id, e.target.value)}>
              <option value="">Select status</option>
              {(statusOptions && statusOptions.length ? statusOptions : FALLBACK_STATUS_OPTIONS).map((opt) => (
                <option key={opt.id} value={opt.id}>{opt.name}</option>
              ))}
            </SelectInput>
          </Label>
        </ActionRow>

        <div style={{ marginTop: 12 }}>
          <div style={{ fontSize: 14, fontWeight: 600, color: "oklch(.145 0 0)", marginBottom: 6 }}>Notes (optional)</div>
          <TextArea
            value={noteValue || ""}
            onChange={(e) => onChangeNote(action.id, e.target.value)}
            placeholder="Add any context, blockers, or updates"
          />
        </div>
      </ActionCard>
    </AnimatedCard>
  );
}
